import { sanitizeHtml } from '@/src/utils/sanitizeHtml';

const setSanitizedHtml = (el, binding) => {
    const value = binding.value;

    if (value && typeof value === 'object' && !Array.isArray(value)) {
        const html = value.html || '';
        const profile = value.profile || binding.arg || 'rich';
        const options = value.options || {};
        el.innerHTML = sanitizeHtml(html, profile, options);
        return;
    }

    const profile = binding.arg || 'rich';
    el.innerHTML = sanitizeHtml(value || '', profile);
};

export default {
    mounted(el, binding) {
        setSanitizedHtml(el, binding);
    },
    updated(el, binding) {
        setSanitizedHtml(el, binding);
    },
};
